import React from 'react';

import {
  Link,
  LoginPanel,
  LoginHeader,
  LinksContain,
  LoginContent,
  MarginBotton,
  SearchLightText,
  SearchLightLogo,
  LoginCard as Card,
  LoginButtonContain
} from './Styled';

import Button from 'components/Button';
import TextInput from 'components/TextInput';
import ErrorDisplay from 'components/ErrorDisplay';

export const LoginCard = ({
  email,
  loading,
  onChange,
  password,
  handleAuth,
  onKeyPress,
  onRegister,
  errorMessage,
  onResetPassword
}) => (
  <LoginPanel>
    <Card>
      <LoginHeader>
        <SearchLightLogo />
        <SearchLightText />
      </LoginHeader>

      <LoginContent>
        <TextInput
          bold
          fullWidth
          name={'email'}
          value={email}
          disabled={loading}
          onChange={onChange}
          onKeyPress={onKeyPress}
          label={'Email Address'}
          placeholder={'Enter your email address'}
        />
        <MarginBotton />
        <TextInput
          bold
          fullWidth
          id="password"
          type={'password'}
          name={'password'}
          label={'Password'}
          value={password}
          onChange={onChange}
          disabled={loading}
          onKeyPress={onKeyPress}
          onFocus={(e) => e.preventDefault()}
          placeholder={'Enter your password'}
        />
        <LoginButtonContain>
          <Button.Primary
            label={'Login'}
            icon={!loading && 'exit_to_app'}
            loading={loading}
            disabled={loading}
            onClick={handleAuth}
          />
        </LoginButtonContain>
        <MarginBotton />
        {!loading && <ErrorDisplay message={errorMessage} />}

        <LinksContain>
          <Link href="#" onClick={onResetPassword}>
            Reset Password
          </Link>

          <div>
            No account?{' '}
            <Link href="#" onClick={onRegister}>
              Register Here
            </Link>
          </div>
        </LinksContain>
      </LoginContent>
    </Card>
  </LoginPanel>
);

export default LoginCard;
